import useCurrentMerchant from 'hooks/useCurrentMerchant'
import React from 'react'
import OrderingNotEnabledPage from '../OrderingNotEnabledPage'
import EditingOverlay from './components/EditingOverlay'
import EmptyState from './components/EmptyState'
import ViewingCard from './components/ViewingCard'
import useCheckoutMessage from './hooks/useCheckoutMessage'

const MAX_CHARS = 500

const CheckoutMessage: React.FC<{ showTitle?: boolean }> = ({
  showTitle = true,
}) => {
  const merchant = useCurrentMerchant()
  const checkout = useCheckoutMessage()

  if (!merchant?.ordering_enabled) {
    return <OrderingNotEnabledPage showTitle={showTitle} />
  }

  if (checkout.mode === 'editing') {
    return (
      <EditingOverlay
        editMessage={checkout.editMessage}
        maxChars={MAX_CHARS}
        isSaving={checkout.isSaving}
        isContentEmpty={
          checkout.editMessage.trim() === '' && !checkout.existingMessage
        }
        onContentChange={checkout.setEditMessage}
        onExitWithoutSaving={checkout.handleExitWithoutSaving}
        onSave={checkout.handleSave}
      />
    )
  }

  if (checkout.mode === 'viewing') {
    return (
      <ViewingCard
        showTitle={showTitle}
        existingMessage={checkout.existingMessage}
        canEdit={checkout.canEdit}
        isLoading={checkout.isLoading}
        isRemoveModalOpen={checkout.isRemoveModalOpen}
        onEdit={checkout.handleEdit}
        onRemove={checkout.handleRemove}
        onOpenRemoveModal={() => checkout.setIsRemoveModalOpen(true)}
        onCloseRemoveModal={() => checkout.setIsRemoveModalOpen(false)}
      />
    )
  }

  return (
    <EmptyState
      showTitle={showTitle}
      canEdit={checkout.canEdit}
      isLoading={checkout.isLoading}
      onAdd={checkout.handleAdd}
    />
  )
}

export default CheckoutMessage
